import React, { useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import api from '../services/api';
import { Lock, ArrowLeft, Loader2, Check } from 'lucide-react';
import { GlassButton } from '../components/ui/GlassButton';
import logoPro from '../logo_pro.png';

export const ResetPassword: React.FC = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const token = searchParams.get('token') || '';
    const [password, setPassword] = useState('');
    const [confirm, setConfirm] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (password.length < 6) { setError('A senha deve ter no m\u00ednimo 6 caracteres.'); return; }
        if (password !== confirm) { setError('As senhas n\u00e3o coincidem.'); return; }
        if (!token) { setError('Link inv\u00e1lido. Solicite um novo.'); return; }

        setLoading(true);
        setError('');
        try {
            await api.post('/auth/reset-password', { token, password });
            setSuccess(true);
            setTimeout(() => navigate('/login'), 3000);
        } catch (err: any) {
            setError(err.response?.data?.error || 'Erro ao redefinir a senha.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-page min-h-screen flex items-center justify-center p-4">
            <div className="auth-card w-full max-w-md bg-white/5 border border-white/10 rounded-[32px] p-10 backdrop-blur-xl relative overflow-hidden">
                <div className="absolute top-[-50%] left-[50%] -translate-x-1/2 w-80 h-80 bg-orange-500/10 rounded-full blur-[80px] pointer-events-none" />
                <div className="relative z-10">
                    <div className="text-center mb-10">
                        <img src={logoPro} alt="Hotlize" className="h-10 mx-auto mb-6" />
                        <h1 className="text-2xl font-bold text-white mb-2">Nova Senha</h1>
                        <p className="text-gray-400 text-sm">Defina sua nova senha de acesso</p>
                    </div>

                    {success ? (
                        <div className="text-center py-8">
                            <div className="w-16 h-16 rounded-full bg-green-500/10 border border-green-500/20 flex items-center justify-center mx-auto mb-4">
                                <Check size={32} className="text-green-500" />
                            </div>
                            <h2 className="text-lg font-bold text-white mb-2">Senha Redefinida</h2>
                            <p className="text-gray-400 text-sm">Redirecionando para o login...</p>
                        </div>
                    ) : (
                        <>
                            {error && (
                                <div className="bg-red-500/10 border border-red-500/20 text-red-500 p-4 rounded-xl mb-6 text-sm text-center">
                                    {error}
                                </div>
                            )}
                            <form onSubmit={handleSubmit} className="space-y-6">
                                <div className="input-group-pro">
                                    <label>NOVA SENHA</label>
                                    <div className="input-wrapper">
                                        <Lock size={18} className="text-gray-500" />
                                        <input
                                            type="password"
                                            placeholder="M\u00ednimo 6 caracteres"
                                            value={password}
                                            onChange={e => setPassword(e.target.value)}
                                            required
                                            minLength={6}
                                            autoFocus
                                        />
                                    </div>
                                </div>
                                <div className="input-group-pro">
                                    <label>CONFIRMAR SENHA</label>
                                    <div className="input-wrapper">
                                        <Lock size={18} className="text-gray-500" />
                                        <input
                                            type="password"
                                            placeholder="Repita a senha"
                                            value={confirm}
                                            onChange={e => setConfirm(e.target.value)}
                                            required
                                        />
                                    </div>
                                </div>
                                <GlassButton type="submit" className="w-full h-14" loading={loading}>
                                    {loading ? <Loader2 className="animate-spin" /> : 'REDEFINIR SENHA'}
                                </GlassButton>
                            </form>
                            <div className="mt-8 text-center text-sm">
                                <Link to="/login" className="text-gray-500 hover:text-white transition-colors">
                                    <ArrowLeft size={14} className="inline mr-1" /> Voltar ao login
                                </Link>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};
